import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';
import initializeI18n from './core/i18n';
import { BrowserRouter } from 'react-router-dom';

initializeI18n();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>  
    <BrowserRouter>
      <main className='dark text-foreground bg-content3'>      
        <App />
      </main>
    </BrowserRouter>
  </React.StrictMode>
);